module.exports = __webpack_public_path__ + "img/streaksVariant.3181f9db.svg";